import { Fancybox } from '@fancyapps/ui';
